import { Customer as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

export type Customer = {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string;
};

export const fromGql = (item: GQLItem): Customer =>
  take(item, 'id', 'firstName', 'lastName', 'email', 'phoneNumber');
